module.exports = __webpack_public_path__ + "static/media/inviter_now_btn.41571c52.png";